import Variable from '@/Services/Formula/Variable';

export default class Formula {
    constructor(formula, debug = false) {
        if (!Array.isArray(formula)) {
            throw new Error('Formula must be an array');
        }

        this._parts = formula;
        this._debugMode = debug;
    }

    get parts() {
        return this._parts;
    }

    /**
     * @param {Array} input
     * @param {Boolean} debug
     * @return {Formula}
     */
    static fromArray(input, debug = false) {
        if (!Array.isArray(input)) {
            throw new Error('Input must be a Formula Array');
        }

        return new Formula(this.parseFormula(input, debug), debug);
    }

    getResult(dataModel) {
        let prepared = [];

        this._parts.forEach((entry, index) => {
            if (index % 2 === 0) {
                // Variable
                prepared.push(entry.getResult(dataModel));
            } else {
                // Operation
                prepared.push(entry);
            }
        });

        let value = prepared.shift();
        prepared = prepared.reduce((accumulator, entry) => {
            let lastItem = accumulator[accumulator.length - 1];

            if (!lastItem || lastItem.length === 2) {
                lastItem = [];
                accumulator.push(lastItem);
            }

            lastItem.push(entry);
            accumulator[accumulator.length - 1] = lastItem;

            return accumulator;
        }, []);

        return prepared.reduce((accumulator, entry) => {
            let operator = entry[0];
            let value = entry[1];

            switch (true) {
                case operator === 'add':
                case operator === 'offset':
                    return accumulator + value;
                case operator === 'subtract':
                    return accumulator - value;
                case operator === 'multiply':
                    return accumulator * value;
                case operator === 'divide':
                    if (value === 0) {
                        return Infinity;
                    }

                    if (value === Infinity) {
                        return 0;
                    }

                    return accumulator / value;
            }

            return accumulator;
        }, value);
    }

    static parseFormula(input, debug = false) {
        if ((input.length % 2) !== 1) {
            throw new Error('Formula invalid');
        }

        let formula = [];

        input.forEach((entry, index) => {
            if (index % 2 === 0) {
                // Variable
                formula.push(new Variable(entry.type, entry.value, debug));
            } else {
                // Operation
                formula.push(entry);
            }
        });

        return formula;
    }
}
